// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
 
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/response.css'
import './assets/js/jquery.qrcode.min.js'
import router from './router'
import axios from 'axios'
 
Vue.use(ElementUI);

Vue.config.productionTip = false

Vue.prototype.$http = axios
Vue.prototype.$axios= axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js